import { render, staticRenderFns } from "./Type4Box.vue?vue&type=template&id=92df1e94&scoped=true"
import script from "./Type4Box.vue?vue&type=script&lang=js"
export * from "./Type4Box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92df1e94",
  null
  
)

export default component.exports